import { render, staticRenderFns } from "./H5Interaction.vue?vue&type=template&id=0b6d9c66&scoped=true"
import script from "./H5Interaction.vue?vue&type=script&lang=js"
export * from "./H5Interaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6d9c66",
  null
  
)

export default component.exports